import { redirect } from "@tanstack/react-router";
import { supabase } from "@/shared/lib/supabase";

/** 비인증 시 로그인 페이지로 리다이렉트. auth 경로는 next에 기입하지 않음. */
export const requireAuth = async ({
  location,
}: {
  location: { pathname: string; href: string };
}) => {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session) {
    const isAuthPath = location.pathname.startsWith("/auth/");
    throw redirect({
      to: "/auth/login",
      search: isAuthPath ? {} : { next: location.href },
    });
  }

  return { session };
};

/** 인증 상태에서는 대시보드로 리다이렉트 (로그인/회원가입 페이지 등). */
export const requireGuest = async () => {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (session) throw redirect({ to: "/dashboard" });
};
